import { Box, Heading } from '@palmetto/palmetto-components';

import { AccountRequirementStatus, MilestoneRequirement, MilestoneType } from 'types';

export const ProgressStatusHeader = ({ milestones = [] }: { milestones?: any[] }) => {
  const milestoneRequirements = milestones.find(
    (milestone: any) => milestone.type === MilestoneType.noticeToProceed,
  )?.requirements;
  let progressText;
  if (
    [AccountRequirementStatus.completed, AccountRequirementStatus.submitted].includes(
      milestoneRequirements?.find((requirement: any) => requirement.type === MilestoneRequirement.contractSigned)
        ?.status,
    )
  ) {
    progressText = 'Active Contract';
  } else if (
    milestoneRequirements?.find((requirement: any) => requirement.type === MilestoneRequirement.quoteActive)
      ?.status === AccountRequirementStatus.completed
  ) {
    progressText = 'Active Quote';
  }

  return progressText ? (
    <Box alignItems="flex-start">
      <Heading as="h5">{progressText}</Heading>
    </Box>
  ) : null;
};
